/**
 * Legacy RateCardsApi module — preserved as an empty AngularJS module + type
 * re-exports so existing dependencies keep resolving:
 *   - `app.module.ts` imports `RateCardsApiServiceModule` (the AngularJS module
 *     name string) and registers it in the root module.
 *   - The legacy `acme.common.service.rateCardsApi` AngularJS module is still
 *     declared as a dep of `acme.common.service.api`.
 *
 * The real implementation now lives at:
 *   apps/b2b-frontend/app/core/api/rate-cards/rate-cards-api.service.ts
 */
import angular from "angular";

export type {
  RateCard,
  RateCardPricing,
  RateCardsApiService,
} from "@ng/core/api/rate-cards/rate-cards-api.service";

export const RateCardsApiServiceModule = angular.module(
  "acme.common.service.rateCardsApi",
  [],
).name;
